import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import Input from '../../Common/ui/input'
import { Button } from '../../Common/ui/button'
import { useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import * as OnboardEntity from '../../Entities/OnBoardingContainerTypes'
import { useTranslation } from 'react-i18next'
import { useCommonStore } from '../../Common/store/CommonStore'
import DropdownTextInput from '../../Common/ui/DropdownTextInput'
// import { Checkbox } from '../../Common/ui/checkbox'
import PhoneNumber from 'src/Common/ui/PhoneNumber'
import { IconButton, Tooltip } from '@mui/material'
import { IoIosCloseCircleOutline } from 'react-icons/io'
import CustomSelect from 'src/Common/ui/CustomSelect'
import { useProfileScreenStore } from 'src/Containers/Onboarding/Store/OnboardingStore'
import * as EndPoints from '../../Entities/EndPoints'
import Axios from 'src/Axios'

const EditBoardDrawer = ({ nodes, editNode, setEditNode, currentNode, setEditState, editState, onEdit, childNodeCount, loading, setLoading }) => {
    const { t } = useTranslation()
    const { register, handleSubmit, reset, resetField, formState: { errors, isLoading, isSubmitting }, control, setError, setValue, clearErrors } = useForm({ mode: 'onChange' })
    const [ windowWidth, setWindowWidth ] = useState(window.innerWidth)
    const { getAllRole } = useCommonStore()
    const orgId = localStorage.getItem('orgId')
    const { getCountryData, getCountry } = useProfileScreenStore()
    const [ country, setCountry ] = useState([])
    const [ stateArrayData, setStateArrayData ] = useState([])
    const [ cityArrayData, setCityArrayData ] = useState([])

    useEffect(() => {
        if (editNode?.atPresent === true) {
            setEditNode({ ...editNode, toDate: new Date() })
        } else {
            setEditNode({ ...editNode, toDate: editNode?.toDate })
        }
    }, [editNode?.atPresent])

    useEffect(() => {
        getAllRole(orgId)
        const handleResize = () => {
            setWindowWidth(window.innerWidth)
        }

        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    useEffect(() => {
        if (editNode) {
            reset({
                firstName: editNode?.firstName,
                lastName: editNode?.lastName,
                emailId: editNode?.emailId,
                phoneNo: editNode?.phoneNo || editNode?.phoneNumber,
                phoneNumber: editNode?.phoneNumber,
                pincode: editNode?.pincode,
                country: editNode?.country,
                state: editNode?.state,
                city: editNode?.city
            })
        }
    }, [ editNode, reset ])

    const resetAll = () => {
        reset()
        resetField(OnboardEntity.PHONE_NUMBER)
    }

    const onSubmit = () => {
        setLoading(true)
        onEdit(currentNode, editNode, childNodeCount, resetAll)
        // setEditNode({})
    }

    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
      event.type === OnboardEntity.KEYDOWN &&
      (event.key === OnboardEntity.TAB || event.key === OnboardEntity.SHIFT)
        ) {
            return
        }

        if (!open) {
            reset()
            resetField(OnboardEntity.PHONE_NUMBER)
            setEditNode({})
        }

        setEditState({ ...editState, [anchor]: open })
    }

    const handleEditFieldsChange = (value, name) => {
        setEditNode(prevNode => {
            const updatedNode = { ...prevNode, [name]: value }

            if (name === OnboardEntity.ADDRESS && !value) {
                updatedNode[OnboardEntity.PIN_CODE] = ''
                updatedNode[OnboardEntity.CITY] = ''
                updatedNode[OnboardEntity.COUNTRY] = ''
                updatedNode[OnboardEntity.STATE] = ''
            }
            if (name === OnboardEntity.COUNTRY) {
                updatedNode[OnboardEntity.STATE] = ''
                updatedNode[OnboardEntity.CITY] = ''
            }
            return updatedNode
        })
        if (name === OnboardEntity.PHONE_NUMBER) {
            setEditNode({
                ...editNode,
                phoneCountryCode: value.countryCode,
                phoneCode: value.phNumberCode,
                phoneNumber: value.phNumber
            })
        }
    }

    const instance = Axios.getInstance()

    useEffect(() => {
        const fetchStates = async () => {
            if (editNode?.country) {
                try {
                    const response = await instance.get(
                        `${EndPoints.API_ENDPOINT}/masterController/states?id=${editNode.country}`
                    )
                    setStateArrayData(response?.data || [])
                } catch (error) {
                    console.error('Error fetching states:', error)
                }
            }
        }

        const fetchCities = async () => {
            if (editNode?.state) {
                try {
                    const response = await instance.get(
                        `${EndPoints.API_ENDPOINT}/masterController/cities?id=${editNode.state}`
                    )
                    setCityArrayData(response?.data || [])
                } catch (error) {
                    console.error('Error fetching cities:', error)
                }
            }
        }

        fetchStates()
        fetchCities()
    }, [ editNode?.country, editNode?.state ])

    useEffect(() => {
        getCountry()
    }, [])

    useEffect(() => {
        if (getCountryData?.length > 0) {
            setCountry(getCountryData)
        }
    }, [getCountryData?.length])

    const handleCancelClose = () => {
        setEditState({ ...editState, right: false })
        reset()
        resetField(OnboardEntity.PHONE_NUMBER)
        setEditNode({})
    }

    return (
        <div>
            <SwipeableDrawer
                PaperProps={{ sx: { width: windowWidth / 1.8, overflowX: 'hidden', zIndex: 0 } }}
                className='m-2 z-auto'
                anchor={'right'}
                open={editState?.right}
                onClose={toggleDrawer('right', false)}
                onOpen={toggleDrawer('right', true)}
            >
                <Box className="p-4 h-[100%]">
                    <div className="flex justify-between items-center pb-3 border-b-2">
                        <h2 className="text-h2 text-primary">{t('Add Management Team')}</h2>
                        <Tooltip title="Close" placement="left" arrow componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <IconButton onClick={() => handleCancelClose()} aria-label="close" disabled={isSubmitting || isLoading || loading}>
                                <IoIosCloseCircleOutline className='text-[hsl(var(--primary))]' />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <div className='flex flex-col h-[90%] justify-between'>
                        <div className='mt-3 h-[90%]'>
                            <div className="grid grid-cols-3 gap-4 mb-2">
                                <div style={{ width: '100%' }}>
                                    <DropdownTextInput
                                        errors={errors}
                                        control={control}
                                        required
                                        rules={{
                                            required: t('First Name is required'),
                                            validate: (value) => {
                                                const titleRegex = /^(Mr\.|Mrs\.|Ms\.|Mx\.|Dr\.)\s*/i
                                                const nameWithoutTitle = value.replace(titleRegex, '').trim()

                                                if (!nameWithoutTitle) {
                                                    return t('First Name cannot be empty spaces')
                                                }
                                                const regex = /^[A-Za-z.]+$/
                                                if (!regex.test(nameWithoutTitle)) {
                                                    return t('First Name must contain only letters')
                                                }
                                                if (nameWithoutTitle.length > 50) {
                                                    return t('First Name must not exceed 50 characters')
                                                }
                                                return true
                                            }
                                        }}
                                        name='firstName'
                                        label={t('First Name')}
                                        placeholder={t('Enter First Name')}
                                        value={editNode?.firstName || ''}
                                        onValueChange={handleEditFieldsChange}
                                        disabled={loading}
                                    />
                                </div>
                                <div style={{ width: '100%' }}>
                                    <Input
                                        errors={errors}
                                        control={control}
                                        name='middleName'
                                        label={t('Middle Name')}
                                        register={register}
                                        placeholder={t('Enter Middle Name')}
                                        type="text"
                                        value={editNode?.middleName || ''}
                                        onValueChange={({ target: { value } }) => handleEditFieldsChange(value, 'middleName')}
                                        rules={{
                                            validate: (value) => {
                                                const middleName = value?.trim()
                                                if (middleName?.length > 30) {
                                                    return t('Middle Name must not exceed 30 characters')
                                                }
                                                return true
                                            }
                                        }}
                                        disabled={loading}
                                    />
                                </div>
                                <div style={{ width: '100%' }}>
                                    <Input
                                        errors={errors}
                                        control={control}
                                        required
                                        rules={{
                                            required: t('Last Name is required'),
                                            validate: (value) => {
                                                const regex = /^[A-Za-z]+$/
                                                const LastName = value.trim()
                                                if (!value.trim()) {
                                                    return t('Last Name cannot be empty spaces')
                                                }
                                                if (!regex.test(value)) {
                                                    return t('Last Name must contain only letters')
                                                }
                                                if (LastName.length > 30) {
                                                    return t('Last Name must not exceed 30 characters')
                                                }
                                                return true
                                            }
                                        }}
                                        name='lastName'
                                        label={t('Last Name')}
                                        register={register}
                                        placeholder={t('Enter Last Name')}
                                        type="text"
                                        value={editNode?.lastName || ''}
                                        onValueChange={({ target: { value } }) => handleEditFieldsChange(value, 'lastName')}
                                        disabled={loading}
                                    />
                                </div>
                                <div style={{ width: '100%', marginBottom: '1rem' }}>
                                    <Input
                                        errors={errors}
                                        control={control}
                                        required
                                        name='emailId'
                                        label={t('Email ID')}
                                        register={register}
                                        placeholder={t('Enter Email ID')}
                                        type="text"
                                        value={editNode?.emailId || ''}
                                        onValueChange={({ target: { value } }) => handleEditFieldsChange(value, 'emailId')}
                                        rules={{
                                            validate: (value) => {
                                                const regexEmail = /^[a-zA-Z0-9.+-_%]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                                if (!value) {
                                                    return t('Email is required')
                                                } else if (!regexEmail.test(value)) {
                                                    return t('Enter a valid email')
                                                }
                                            },
                                            required: t('Email is required')
                                        }}
                                        disabled={loading}
                                        userId={+editNode?.userId}
                                    />
                                </div>
                                <div style={{ width: '100%', marginBottom: '1rem' }}>
                                    <PhoneNumber
                                        name={'phoneNo'}
                                        value={editNode?.phoneNumber ? `${editNode?.phoneCode || ''}${editNode?.phoneNumber}` : ''}
                                        control={control}
                                        placeholder={t('Enter phone number')}
                                        label={t('Phone Number')}
                                        register={register}
                                        required={true}
                                        rules={{
                                            validate: (value) => {
                                                const regexPhone = /^[0-9]{10}$/
                                                if (value && !regexPhone.test(value)) {
                                                    return 'Phone number must be 10 digits'
                                                }
                                            }
                                        }}
                                        errors={errors} setValue={setValue} setError={setError} clearErrors={clearErrors}
                                        onValueChange={(value) => handleEditFieldsChange(value, OnboardEntity.PHONE_NUMBER)}
                                        disabled={loading}
                                        userId={+editNode?.userId}
                                    />
                                    {/* <Input name={'phoneNo'} type='number' placeholder='Enter Phone Number' label='Phone Number' value={editNode?.phoneNo} onValueChange={({ target: { value } }) => handleEditFieldsChange(value, 'phoneNo')}
                                        rules={{
                                            validate: (value) => {
                                                const regexPhone = /^[0-9]{10}$/
                                                if (value && !regexPhone.test(value)) {
                                                    return 'Phone number must be 10 digits'
                                                }
                                            }
                                        }} control={control} errors={errors} setError={setError} clearErrors={clearErrors}/> */}
                                </div>
                                {/* <div style={{ width: '100%', justifyItems: 'center', marginBottom: '1rem', alignContent: 'center' }}>
                                    <Checkbox
                                        disabled
                                        name="sendNotification"
                                        checked={editNode?.sendNotification || false}
                                        onCheckedChange={(e) => handleEditFieldsChange(e, 'sendNotification')}
                                        className='mt-4'
                                    />
                                    <label className='grc-label-one ml-2'>{t('Do you want to send notification?')}</label>
                                </div> */}
                            </div>
                            <div className="grid grid-cols-3 gap-4 my-2">
                                <div className='col-span-2' style={{ width: '100%' }}>
                                    <Input name='address' className='!w-[98%]' type='text' placeholder='Enter Apartment / House / Street' label='Apartment / House / Street' value={editNode?.address || ''} onValueChange={({ target: { value } }) => handleEditFieldsChange(value, 'address')} rules={{
                                        validate: (value) => {
                                            if (value) {
                                                const address = value.trim()
                                                if (!value.trim()) {
                                                    return t('Address cannot be empty spaces')
                                                }
                                                if (address.length > 50) {
                                                    return t('Address must not exceed 50 characters')
                                                }
                                                return true
                                            }
                                            return true
                                        }
                                    }} control={control} errors={errors}
                                    disabled={loading}
                                    />
                                </div>
                                <div className='col-span-1' style={{ width: '100%' }}>
                                    <CustomSelect
                                        name={'country'}
                                        disabled={!editNode?.address || loading}
                                        label={t('Country')}
                                        value={editNode?.country || ''}
                                        onValueChange={(value) => handleEditFieldsChange(value, 'country')}
                                        options={country}
                                        placeholder={t('Select country')}
                                        errors={errors}
                                        control={control}
                                        required={editNode?.address}
                                        rules={{ required: editNode?.address ? t('This field is required') : false }}
                                    />
                                </div>
                            </div>
                            <div className="grid grid-cols-3 gap-4 mb-2">
                                <div style={{ width: '100%' }}>
                                    <CustomSelect
                                        name={'state'}
                                        disabled={!editNode?.address || loading || !editNode?.country}
                                        label={t('State')}
                                        value={editNode?.state || ''}
                                        onValueChange={(value) => handleEditFieldsChange(value, 'state')}
                                        options={stateArrayData}
                                        placeholder={t('Select State')}
                                        errors={errors}
                                        control={control}
                                        required={editNode?.address}
                                        rules={{ required: editNode?.address ? t('This field is required') : false }}
                                    />
                                </div>
                                <div style={{ width: '100%' }}>
                                    <CustomSelect
                                        name={'city'}
                                        disabled={!editNode?.address || loading || !editNode?.state}
                                        label={t('City')}
                                        value={editNode?.city || ''}
                                        onValueChange={(value) => handleEditFieldsChange(value, 'city')}
                                        options={cityArrayData}
                                        placeholder={t('Select City')}
                                        errors={errors}
                                        control={control}
                                        required={editNode?.address}
                                        rules={{ required: editNode?.address ? t('This field is required') : false }}
                                    />
                                </div>
                                <div style={{ width: '100%' }}>
                                    <Input
                                        name='pincode'
                                        type='number'
                                        placeholder='Enter Pincode'
                                        label='Pin Code'
                                        disabled={!editNode?.address || loading}
                                        value={editNode?.address ? editNode?.pincode : ''}
                                        required={editNode?.address} errors={errors} control={control}
                                        rules={editNode?.address?.length > 0
                                            ? {
                                                required: t('This field is required'),
                                                validate: (value) => {
                                                    if (value) {
                                                        if (editNode?.address) {
                                                            if (!/^\d{6}$/.test(value)) {
                                                                return t('Pincode must be exactly 6 digits')
                                                            }
                                                            return true
                                                        } else {
                                                            return true
                                                        }
                                                    }
                                                }
                                            }
                                            : {}}
                                        onValueChange={({ target: { value } }) => handleEditFieldsChange(value, 'pincode')}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="flex justify-end space-x-4">
                            <Button
                                variant='outline'
                                style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                                onClick={() => handleCancelClose()}
                                disabled={loading}
                            >
                                {t('Cancel')}
                            </Button>
                            <Button onClick={handleSubmit(onSubmit)} disabled={isSubmitting || isLoading || loading}>
                                {loading ? t('Updating...') : t('Update')}
                            </Button>
                        </div>
                    </div>
                </Box>
            </SwipeableDrawer>
        </div>
    )
}

EditBoardDrawer.propTypes = {
    nodes: PropTypes.object,
    editNode: PropTypes.object,
    setEditNode: PropTypes.func,
    currentNode: PropTypes.object,
    setEditState: PropTypes.func,
    editState: PropTypes.object,
    onEdit: PropTypes.func,
    childNodeCount: PropTypes.number,
    loading: PropTypes.bool,
    setLoading: PropTypes.bool
}

export default EditBoardDrawer
